import React from 'react';
import { contactBg } from '../../assets/images';
import { Link } from 'react-router-dom';

const AppTitle = ({ title, bgImg, link, from, to }) => {
  return (
    <div className='breadcrumb' style={{ backgroundImage: `url(${bgImg ?? contactBg})` }}>
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='breadcrumb_content'>
              <h1 className='breadcrumb_title'>{title}</h1>
              <ul className='breadcrumb_list'>
                <li>
                  <Link to={link ?? '/'}>{from}</Link>
                </li>
                <li>{to}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppTitle;
